import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Card = styled.div`
  border: 1px solid ${colors.borderGrey};
  border-radius: 8px;

  & > * {
    padding: ${space[3]} ${space[4]};
  }

  & > *:not(:last-child) {
    border-bottom: 1px solid ${colors.borderGreyLighter};
  }

  & label {
    font-size: ${fonts.size.xs};
    font-weight: ${fonts.weight.normal};
    color: ${colors.fontSecondary};
  }

  & input {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.medium};
    outline: none;
  }

  & textarea {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.medium};
    outline: none;
    border-radius: 0;
  }

  & button[aria-haspopup='listbox'] {
    border: none;
    padding: 0;
    font-size: ${fonts.size.md};
    font-weight: ${fonts.weight.medium};
    min-width: unset;
    width: 100%;
    background: transparent;
  }

  & div:has(> button[aria-haspopup='listbox']) {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  & [role='listbox'] {
    left: calc(-1 * ${space[4]} - 1px);
    right: calc(-1 * ${space[4]} - 1px);
    top: calc(100% + ${space[3]});
    border-radius: 0 0 8px 8px;
    border-top: 1px solid ${colors.borderGreyLighter};
  }

  & [role='listbox'] input {
    padding: ${space[3]} ${space[4]};
    border-bottom: 1px solid ${colors.borderGrey};
  }

  & [role='listbox'] [role='option'] {
    padding: ${space[3]} ${space[4]};
  }
`;
